export const en = {
    'logo': 'Khural',
    'last-khurals': 'Past khurals',
};
